__turbopack_context__.v({
  "cta": "ExtraLabel-module__KPEzQW__cta",
  "extraLabel": "ExtraLabel-module__KPEzQW__extraLabel",
  "highlight": "ExtraLabel-module__KPEzQW__highlight",
  "icon": "ExtraLabel-module__KPEzQW__icon",
  "info": "ExtraLabel-module__KPEzQW__info",
});
